export const securityQuestions = [
  "what is your nick name?",
  "what is your pet name?",
  "what is your favourite cricketer?",
  "what is your hobby?",
];
